module.exports = __webpack_public_path__ + "assets/imgs/news-page-img-3-2.v1.jpg";